import React, { createContext, useContext, useState } from 'react';

const TextContext = createContext();

export const useText = () => useContext(TextContext);

export const TextProvider = ({ children }) => {
    const [savedText, setSavedText] = useState("");

    const updateSavedText = (newText) => {
        setSavedText(newText);
    };

    return (
        <TextContext.Provider value={{ savedText, updateSavedText }}>
            {children}
        </TextContext.Provider>
    );
};
